// src/pages/HomePage.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HireMe from '../components/HireMe';
import Home from './Home';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import CaseStudies from './CaseStudies';
import Publications from './Publications';
import Blog from './Blog';
import Gallary from './Gallery';
import Experience from './Experience';
import Contact from './Contact';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    // 1. Disable browser's automatic scroll restoration to avoid restoring previous scroll (e.g. footer)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // 2. Before page unloads/refreshes, reset scroll to top
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // 3. Detect if this is a page refresh / reload
    const navEntries = window.performance?.getEntriesByType?.('navigation');
    const isReload = navEntries?.[0]?.type === 'reload' || window.performance?.navigation?.type === 1;

    if (isReload) {
      // Clear hash so refresh stays at the hero section
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname);
      }
      window.scrollTo(0, 0);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    // 4. In-app navigation with hash (e.g., coming from /project/:id)
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        const timer = setTimeout(() => {
          const yOffset = -70;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          // Clean hash from URL so future refreshes won't scroll down to footer
          window.history.replaceState(null, '', window.location.pathname);
        }, 100);
        return () => {
          clearTimeout(timer);
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }
    } else {
      window.scrollTo(0, 0);
    }

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white dark:bg-[#12121a] text-[#393e46] dark:text-[#e1dfed] font-body transition-colors duration-300">
      <Navbar />
      <main>
        <Home />
        <About />
        <Skills />
        <Projects />
        <CaseStudies />
        <Experience />
        <HireMe />
        <Publications />
        <Blog />
        <Gallary />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
